module.exports = {
  redeem: 'redeem',
  'redeem-voucher': 'Redeem voucher',
  endless: 'unlimited',
  redeemed_vouchers: 'Voucher codes that have already been redeemed',
  valid_until: 'Expires:',
  redeemed_at: 'Redeemed: %{date}',
  please_enter_code: 'Please enter a voucher code',
  voucher_redeemed: 'The voucher has been redeemed.',
  voucher_failed_to_redeem: 'Unfortunately, your voucher could not be redeemed',
  invalid_voucher_description: 'Please check the spelling. Contact %{adminEmail} if it still does not work.',
}
